import DashboardCard from "./DashboardCard";
import useFetchDashboardBotPerformance from "../../hooks/api/useFetchDashboardBotPerformance";
import { BsRobot } from "react-icons/bs";
import { useSelector } from "react-redux";
import BotPerformanceLoader from "./bot-performance/BotPerformanceLoader";
import NoBotMessage from "./bot-performance/NoBotMessage";
import BotPerformancePreview from "./bot-performance/BotPerformancePreview";
import styles from "../../styles/Components/new-dashboard/BotPerformance.module.css";
import BotOverallPerformance from "./bot-performance/BotOverallPerformance";
import BotLists from "./bot-performance/BotLists";
import BotPerformanceChart from "../../shared/BotPerformanceChart";
import CreateBot from "../bot/CreateBot";
import { Popover } from "antd";
import { FaArrowRight } from "react-icons/fa6";
import CustomButton from "../../ui/CustomButton";
import { useNavigate } from "react-router-dom";
import { FaChartBar, FaCaretDown } from "react-icons/fa";
import React from "react";

function BotPerformance() {
  const {
    dashboard: { botInfo, botInfoStatus, overallBotPerformance },
  } = useSelector((state) => state);

  const { number_of_bots: botsNum } = botInfo;

  const {
    overall_performance: {
      balance_date_list: balanceDates,
      balance_lists: balanceLists,
    } = {},
    status,
  } = overallBotPerformance;

  useFetchDashboardBotPerformance();

  const navigate = useNavigate();

  return (
    <>
      <DashboardCard
        title="Bot Performance & Management"
        // open={window.innerWidth > 768}
        titleIcon={<BsRobot />}
        preview={<BotPerformancePreview />}
        actions={
          <div className={styles.headerActions}>
            <CreateBot className={styles.addBot} />
            <CustomButton
              type="primary"
              className={styles.navigationBtn}
              onClick={() => navigate("/bot-automation")}
            >
              <FaArrowRight />
              To Bot Management
            </CustomButton>
          </div>
        }
        bodyClassName={styles.cardBody}
        type="botPerformance"
      >
        {botInfoStatus === "loading" && <BotPerformanceLoader />}
        {botInfoStatus === "error" && <div className={styles.errorBox}>
          <BsRobot size={50} color="rgb(108,117,125)" />
          <p>Data couldn’t be loaded right now. Please try again later.</p>
        </div>}

        {botInfoStatus === "success" && botsNum === 0 && <NoBotMessage />}

        {botInfoStatus === "success" && botsNum > 0 && (
          <>
            {/*<BotOverallPerformance />*/}
            <BotLists />
            {status === "ok" && (
              <BotPerformanceChart
                wrapperClassName={styles.chartContainer}
                balanceLists={balanceLists}
                balanceDateList={balanceDates}
                header={
                  <Popover
                    content={<BotOverallPerformance />}
                    className={styles.popover}
                    overlayInnerStyle={{ minWidth: "320px" }}
                    rootClassName={styles.content}
                  >
                    <FaChartBar />
                    All Bots Summary
                    <FaCaretDown />
                  </Popover>
                }
              />
            )}

            {/*<BotFeatures />*/}
          </>
        )}
      </DashboardCard>
    </>
  );
}

export default BotPerformance;
